export const theme = {
    colors: {
        primary: '#003E57',
        primaryLight: '#00506e',
        primaryDark: '#002d40',
        secondary: '#E8EFF2',
        accent: '#2196F3',
        success: '#4CAF50',
        warning: '#FF9800',
        danger: '#F44336',

        text: '#333333',
        textMuted: '#666666',
        textLight: '#999999',

        background: '#F5F7FA',
        cardBg: '#FFFFFF',
        border: '#E0E0E0',

        // Status colors
        statusGreen: '#4CAF50',
        statusYellow: '#FFC107',
        statusOrange: '#FF9800',
        statusRed: '#F44336',
        statusBlue: '#2196F3',
        statusGray: '#9E9E9E',

        // LinkedIn assignment (learning task) timeline bar
        linkedinAssignment: '#9C27B0',
    },

    fonts: {
        heading: "'Montserrat', sans-serif",
        body: "'Open Sans', sans-serif",
    },

    fontSizes: {
        xs: '0.75rem',
        sm: '0.85rem',
        md: '1rem',
        lg: '1.25rem',
        xl: '1.5rem',
        xxl: '2rem',
    },

    spacing: {
        xs: '0.25rem',
        sm: '0.5rem',
        md: '1rem',
        lg: '1.5rem',
        xl: '2rem',
        xxl: '3rem',
    },

    borderRadius: {
        sm: '4px',
        md: '8px',
        lg: '12px',
        xl: '16px',
        round: '50%',
    },

    shadows: {
        sm: '0 1px 3px rgba(0,0,0,0.1)',
        md: '0 4px 6px rgba(0,0,0,0.1)',
        lg: '0 10px 20px rgba(0,0,0,0.15)',
        xl: '0 15px 30px rgba(0,0,0,0.2)',
    },

    transitions: {
        fast: '0.15s ease',
        normal: '0.2s ease',
        slow: '0.3s ease',
    },
}

export type Theme = typeof theme
